import {
  getCouponPageRules,
  resolveCouponReach,
  type CouponPriceLine,
  type CouponPurchase,
  type CouponScope,
} from '@repo/lib';

type CouponCartPurchase = Pick<CouponPurchase, 'ticketTypeIds' | 'bumpProductIds'>;

/**
 * If true, the coupon applies per ticket on this event: every rule naming the page is a tickets or
 * ticketsAndAddOns rule. A coupon without rules is read as main stored it, so one naming ticket
 * types of this event is a ticket coupon.
 */
export const checkIsTicketTypeCoupon = (
  coupon: CouponScope | null | undefined,
  pageId: string,
  pageTicketTypes: string[] = [],
) => {
  if (!coupon || !pageId) return false;

  const rules = getCouponPageRules(coupon, { pageId, pageTicketTypeIds: pageTicketTypes });
  return (
    rules.length > 0 &&
    rules.every(rule => rule.appliesTo === 'tickets' || rule.appliesTo === 'ticketsAndAddOns')
  );
};

/**
 * If true, the coupon takes its order-level discount off a checkout's main product at the selected
 * price, or an event's tickets together. `purchase` holds the tickets and bumps in the cart, which
 * the rules needing a bump match on.
 */
export const checkIsOrderCoupon = (
  coupon: CouponScope | null | undefined,
  pageId: string,
  pageTicketTypes: string[] = [],
  primary?: CouponPriceLine | null,
  purchase: CouponCartPurchase = {},
) =>
  resolveCouponReach(coupon, {
    pageId,
    pageTicketTypeIds: pageTicketTypes,
    priceId: primary?.priceId,
    ...purchase,
  }).primaryScope === 'order';
